import axios from 'axios'
import { fetchAuthSession } from 'aws-amplify/auth'

export async function getAll(url, page = 1) {
  const session = await fetchAuthSession()
  const idToken = session.tokens && session.tokens.idToken && session.tokens.idToken.toString()
  const response = await axios.get(url, {
    params: {_page: page, _limit: process.env.REACT_APP_PAGE_SIZE},
    headers: {
      Authorization: 'Bearer ' + idToken,
    },
  })
  return {content: response.data, totalCount: Number(response.headers['x-total-count'])}
}

export async function post(url, body) {
  const session = await fetchAuthSession()
  const idToken = session.tokens && session.tokens.idToken && session.tokens.idToken.toString()
  const response = await axios.post(url, body, {
    headers: {
      Authorization: 'Bearer ' + idToken,
    },
  })
  return response.data
}

export async function getById(url, id) {
  const session = await fetchAuthSession()
  const idToken = session.tokens && session.tokens.idToken && session.tokens.idToken.toString()
  const response = await axios.get(url + '/' + id, {
    headers: {
      Authorization: 'Bearer ' + idToken,
    },
  })
  return response.data
}

export async function deleteById(url, id) {
  const session = await fetchAuthSession()
  const idToken = session.tokens && session.tokens.idToken && session.tokens.idToken.toString()
  return await axios.delete(url + '/' + id, {
    headers: {
      Authorization: 'Bearer ' + idToken,
    },
  })
}

export async function putById(url, id, body) {
  const session = await fetchAuthSession()
  const idToken = session.tokens && session.tokens.idToken && session.tokens.idToken.toString()
  return await axios.put(url + '/' + id, body, {
    headers: {
      Authorization: 'Bearer ' + idToken,
    },
  })
}
